export const systemJa = {
  // LegalPage
  'system.legal.fallbackTitle': 'ドキュメント',
  'system.legal.fallbackBody': '見つかりません。',
  'system.legal.lastUpdated': '最終更新：{date}',

  // NotFoundPage
  'system.notFound.seoTitle': 'ヴェイルで迷い込んで',
  'system.notFound.heading': 'あなたは地図の縁を越えてさまよい出てしまった',
  'system.notFound.body': 'あなたが求めた道は永遠の黄昏に飲み込まれてしまった。',
  'system.notFound.returnCta': 'ヴェイルに戻る',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': 'ヴェイルが謎の揺らぎに揺らいだ。',
  'system.error.seoTitle': 'ヴェイルの波乱',
  'system.error.heading': 'その儀式は失敗に終わった',
  'system.error.body':
    '目に見えぬ何かがこのページを妨害した。ここはヴェイルが薄い——もう一度試すか、より安全な地へ戻るのだ。',
  'system.error.tryAgain': '再度試す',
  'system.error.returnCta': 'ヴェイルに戻る',
  'licenseGate.heading': "近日公開 — ライセンスの都合により制限中",
  'licenseGate.body': "この言語版はライセンスの都合でまだご利用いただけません。準備を進めています。またのお越しをお待ちください。",
} as const
